import { store } from '@/state/store';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { MAP__fields_by_id } from '@shared/types/types';
import { LOCAL__ui_set_field_for_generation_layout } from '../image/LOCAL__ui_set_field_for_generation_layout';

export function FN_UI__try_update_generation_layout_image_edit(
  generation: DTO__generation,
  //key - field_id
  fields_map: MAP__fields_by_id,
) {
  const { g_image_edit__field: field } = store.getState().slice_ui;

  if (field.is_stub()) return; //nothing to update

  let { graph } = generation.tool;

  //   todo: mb need check by node id in graph because update on fullscreen can create new generation
  if (field.meta.graph_id != graph.meta.graph_id) return;

  let field_updated: FIELD__image_asset;

  if (fields_map.has(field.meta.field_id)) {
    let field_from_graph = fields_map.get_or_assert(field.meta.field_id);
    assert_instanceof(field_from_graph, FIELD__image_asset);
    field_updated = field_from_graph.clone();
  } else {
    field_updated = FIELD__image_asset.CREATE_STUB();
  }

  store.dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_image_edit__field', field: field_updated }));
}
